import React, { useState, useEffect } from "react";
import { PartsDatabase } from "./PartsDatabase";
import { VendorDatabase } from "./VendorDatabase";
import { ConsigneeDatabase } from "./ConsigneeDatabase";
import { PurchaserDatabase } from "./PurchaserDatabase";
import { DeviceCompatibilityNotice } from './DeviceCompatibilityNotice';

type DatabaseSection = "parts" | "vendors" | "consignees" | "purchasers";

export const Database: React.FC = () => {
  const [activeSection, setActiveSection] = useState<DatabaseSection>("parts");
  const [isViewportTooSmall, setIsViewportTooSmall] = useState(false);
  const MINIMUM_VIEWPORT_WIDTH = 850;

  useEffect(() => {
    const checkViewportWidth = () => {
      setIsViewportTooSmall(window.innerWidth < MINIMUM_VIEWPORT_WIDTH);
    };

    checkViewportWidth();
    window.addEventListener('resize', checkViewportWidth);

    return () => {
      window.removeEventListener('resize', checkViewportWidth);
    };
  }, []);

  if (isViewportTooSmall) {
    return (
      <div className="w-full">
        <h2 className="text-xl font-bold mb-4">Database</h2>
        <DeviceCompatibilityNotice
          minWidth={MINIMUM_VIEWPORT_WIDTH}
          title="Database View Limited"
          customMessage="The database view requires a larger screen. Please use a tablet or desktop device."
        />
      </div>
    );
  }

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Database Management</h2>

      <div className="mb-6">
        <div className="flex space-x-2 border-b border-gray-200 dark:border-gray-700">
          <button
            onClick={() => setActiveSection("parts")}
            className={`px-4 py-2 font-medium text-sm ${activeSection === "parts"
              ? "border-b-2 border-indigo-600 text-indigo-600"
              : "text-gray-600 dark:text-gray-400 hover:text-indigo-600"
              }`}
          >
            Parts
          </button>
          <button
            onClick={() => setActiveSection("vendors")}
            className={`px-4 py-2 font-medium text-sm ${activeSection === "vendors"
              ? "border-b-2 border-indigo-600 text-indigo-600"
              : "text-gray-600 dark:text-gray-400 hover:text-indigo-600"
              }`}
          >
            Vendors
          </button>
          <button
            onClick={() => setActiveSection("consignees")}
            className={`px-4 py-2 font-medium text-sm ${activeSection === "consignees"
              ? "border-b-2 border-indigo-600 text-indigo-600"
              : "text-gray-600 dark:text-gray-400 hover:text-indigo-600"
              }`}
          >
            Consignees
          </button>
          <button
            onClick={() => setActiveSection("purchasers")}
            className={`px-4 py-2 font-medium text-sm ${activeSection === "purchasers"
              ? "border-b-2 border-indigo-600 text-indigo-600"
              : "text-gray-600 dark:text-gray-400 hover:text-indigo-600"
              }`}
          >
            Purchasers
          </button>
        </div>
      </div>

      <div className="bg-white dark:bg-gray-800 shadow rounded-lg">
        {activeSection === "parts" && <PartsDatabase />}
        {activeSection === "vendors" && <VendorDatabase />}
        {activeSection === "consignees" && <ConsigneeDatabase />}
        {activeSection === "purchasers" && <PurchaserDatabase />}
      </div>
    </div>
  );
};
